/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NormalCard from "../../../cards/NormalCard";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 1rem 0rem",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1.875rem",
  },
  subHeading: {
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.6875rem",
    },
  },
  accordionContainer: {
    width: "100%",
  },
}));

const SectionThree = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Accordion
          square
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className={classes.accordionContainer}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={props.ariacontrols}
            id={props.id}
          >
            <Typography
              variant="h5"
              component="h5"
              className={classes.subHeading}
            >
              Paper Work
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordiondetail}>
            <div className={classes.flex}>
              <NormalCard
                icon="/images/icons/service/liaising_documentation.svg"
                title="Documentation Support"
                text="Sit back and relax, while we take care of your documentation"
              />
              <NormalCard
                icon="/images/icons/service/legal_services.svg"
                title="Legal"
                text="A panel of veterans for all your legal related affairs and queries"
              />
              <NormalCard
                icon="/images/icons/service/jd.svg"
                title="Liaising"
                text="Flexible solutions under a single-window"
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </React.Fragment>
  );
};

export default SectionThree;
